.region {
  position: fixed;
  right: var(--space-5);
  bottom: var(--space-5);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: min(26rem, calc(100vw - var(--space-7)));
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background-color: var(--color-surface);
  box-shadow: var(--shadow-lg);
  pointer-events: auto;
  animation: slide-in var(--transition-normal);
}

.icon {
  margin-top: 0.125rem;
}

.success .icon {
  color: var(--color-success);
}

.error .icon {
  color: var(--color-danger);
}

.info .icon {
  color: var(--color-info);
}

.message {
  flex: 1;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
}

.close {
  display: inline-flex;
  padding: var(--space-1);
  border: none;
  border-radius: var(--radius-sm);
  background: none;
  color: var(--color-text-muted);
}

@media (width < 40rem) {
  .region {
    right: var(--space-3);
    bottom: calc(var(--layout-bottom-nav-height) + var(--space-3));
  }
}

@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateY(0.5rem);
  }
}
